<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid>
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <strong>Confirm Availability and Total Rate</strong>
                                  </v-col>

                                  <v-col cols="3">
                                      <strong>Total Rate:</strong>
                                  </v-col>


                                  <v-col cols="9">
                                      <v-layout wrap>

                                      <v-col cols="12">
                                          <v-radio-group
                                              v-model="quoteNotPossible"
                                              row
                                              autocomplete
                                          >
                                              <v-radio label="A quote cannot be given at this time" :value="1"></v-radio>
                                              <v-radio label="A quote can be given" :value="0"></v-radio>
                                          </v-radio-group>
                                      </v-col>


                                      <v-col cols="12">
                                          <v-container fluid>
                                               <v-layout row>
  
                                                  <v-col cols="3">
                                                      <strong>Non-Commissionable Extras</strong>
                                                  </v-col>
                                                  <v-col cols="9">
                                                      Non-Commissionable Extras 
                                                  </v-col>


                                                  <v-col cols="3">
                                                      <strong>Total Cost Inclusive</strong>
                                                  </v-col>
                                                  <v-col cols="9">
                                                      Total Cost Inclusive
                                                  </v-col>


                                                  <v-col cols="3">
                                                      <strong>Total Quote {{ reservation.hotel.currency.currency_code }}:</strong>
                                                  </v-col>
                                                  <v-col cols="9">
                                                          <v-text-field 
                                                              class="text-right align-right"
                                                              v-on:change="updateSeparateRatesFromTotalRates()"
                                                              v-model="totalRates"
                                                          ></v-text-field>
                                                  </v-col>
                                                  

                                              </v-layout>
                                          </v-container>
                                      </v-col>

                               </v-layout>
                               </v-col>

                                  <v-col cols="3">
                                      <strong>Deposit:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <div v-if="reservation.depositRequired"><strong>Deposit required at time of booking {{ reservation.deposit_amount_local }} {{ reservation.hotel.currency.currency_code }}</strong></div>
                                      <div v-if="reservation.is_advance_payment">Full pre-payment charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'UPF' && reservation.hotel.collect_deposit == 1">Amount charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'ARR' && (!reservation.voucher_key)">i-escape has not charged the clients card</div>
                                  </v-col>


                                  <!-- This needs to be per unit -->
                                  <v-col cols="3">
                                      <strong>Payment Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      To do
                                  </v-col>

                                  <v-col cols="3">
                                      <strong>Cancellation Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <textarea></textarea>
                                  </v-col>
                                  <!-- End per unit -->



                               <v-col cols="3">
                                   <strong>Quote Valid Until</strong>
                               </v-col>
                               <v-col cols="9">
                                   <v-date-picker v-model="reservation.quote_expiry" no-title scrollable>
                                   </v-date-picker> at midnight (GMT)
                                   <div><strong>NOTE</strong> this shows {{ reservation.hotel.holds_rooms }} days from now. Please change it if you cannot keep the room/s on option for {{ reservation.hotel.holds_rooms }} days. Ensure that you keep the accommodation/service quoted on available for the specified validity period.</div>
                               </v-col>

                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="ies-green" v-on:click="sendQuote">Send to client</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservations
     * by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    export default {
        name: 'hotel-reservation-enquiry',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                quote: {},
                quoteNotPossible: 0,
                totalRates: 0.0
            }
        },
        methods: {

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;

                    // Set a property to dictate whether the booking would require the client to pay a deposit
                    // The logic being if i-escape collects one for the hotel, or the rates require one, or the
                    // hotel's policy requires it for all bookings
                    console.log("quote accept: ",this.reservation);
                    this.reservation.depositRequired = this.reservation.hotel.collect_deposit || this.reservation.is_advance_payment || ((this.reservation.hotel.hotel_payment_policy.deposit_required == 1) || (this.reservation.hotel.hotel_payment_policy.deposit_required == 2));
                    if (!this.reservation.quote_expiry){
                        var date = new Date();
                        date.setDate(date.getDate() + 5);
                        this.reservation.quote_expiry = date.getUTCFullYear() +"-"+ (date.getUTCMonth()+1) +"-"+ date.getUTCDate();
                    }

                    var startDate = Date.parse(this.reservation.date_arrival);
                    console.log(startDate);
                    for(var index=0; index < this.reservation.stay_length; index++){
                        var datePointer = new Date(startDate.valueOf());
                        datePointer.setDate(datePointer.getDate() + index);
                        var dateString = datePointer.getUTCDate() + " " + this.getMonthAbbreviated(datePointer.getUTCMonth()) + " " + datePointer.getUTCFullYear() + ', ' + this.getDayAbbreviated(datePointer.getDay())
                        //this.quote.push({ "dateString": dateString, "date": date, "rateValue": 0.0 })
                    }
                    console.log(this.dateRange);


                    console.log("offer quote: ", this.reservation);

                    // Set up view models with initial values
                    this.updateTotalRatesFromSeparateRates();
                }.bind(this));
            },
/*
            makeEmptyQuote(reservation){
                var quote = {rooms: []};
                reservation.units.forEach(function(unit){
                   quote. 
                });
                this.quote = quote;
            },
*/
            sendQuote(){
                axios.post('/api/reservations/' + this.reservationkey + '/send-quote', {"reservation": this.reservation})
                .then(function(response){
                    alert("Quote sent to client");
                }.bind(this));
            },

            /**
             * Returns the day of the week by abbreviated name
             * e.g. 1 = "Mon", 2 = "Tue" etc
             */
            getDayAbbreviated(dayIndex){
                var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                return days[dayIndex];
            },

            /**
             * Returns the month of the year by abbreviated name
             * e.g. 1 = "Feb", 2 = "Mar" etc
             */
            getMonthAbbreviated(monthIndex){
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return months[monthIndex];
            },


            /**
             * @method dateFormatDDMYYYYDay
             *
             * Takes a date string in the format YYYY-MM-DD and returns it in the designed format
             * e.g. '17 September 2025, Wednesday'
             *
             * @param String dateString
             * @return String
             */
            dateFormatDDMYYYYDay(dateString){
               var parts = dateString.replace('T', '-').split('-');
               var myDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]), 0, 0, 0);
               return myDate.getDate() + " " + this.getMonthName(myDate.getMonth()) + " " + myDate.getFullYear() + ", " + this.getDayName(myDate.getDay());
            },

            getMonthName(monthIndex){
                switch(monthIndex){
                    case 0: return "January";
                    case 1: return "February";
                    case 2: return "March";
                    case 3: return "April";
                    case 4: return "May";
                    case 5: return "June";
                    case 6: return "July";
                    case 7: return "August";
                    case 8: return "September";
                    case 9: return "October";
                    case 10: return "November";
                    case 11: return "December";
                }
                return "Unknown";
            },


            getDayName(dayIndex){
                switch(dayIndex){
                    case 0: return "Sunday";
                    case 1: return "Monday";
                    case 2: return "Tuesday";
                    case 3: return "Wednesday";
                    case 4: return "Thursday";
                    case 5: return "Friday";
                    case 6: return "Saturday";
                }
                return "Unknown";
            },


            updateTotalRatesFromSeparateRates(){
                var totalRates = 0.00;
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalRates += Math.max(0.0, stdRate.rate);
                    });
                });
                this.totalRates = totalRates;

                // Update the rest of the fields such as commssion/deposit
                this.reservation.commission_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
                this.reservation.deposit_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
            },


            updateSeparateRatesFromTotalRates: function () {
                var pricePerEntry = 0.00;
                var totalNumEntries = 0;

                // Before we can divide the total price evenly across the quote
                // we need to know how many things we are dividing it between
                // so we can calculate the individual price values
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalNumEntries++;
                    });
                });
              
                // Calculate the price per entry needed to add up to the total quote price
                pricePerEntry = Math.max(1.0, parseFloat(this.totalRates)) / totalNumEntries; 

                // Update the individual values to this such that the entire quote will
                // add up to the value the hotelier just plucked from the sky
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        stdRate.rate = pricePerEntry;
                    });
                });

                // Update the rest of the fields such as commssion/deposit
                this.reservation.commission_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
                this.reservation.deposit_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
		    }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {},

/*
        watch: {
            totalRates: function (newValue) {
                var pricePerEntry = 0.00;
                var totalNumEntries = 0;

                // Before we can divide the total price evenly across the quote
                // we need to know how many things we are dividing it between
                // so we can calculate the individual price values
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalNumEntries++;
                    });
                });
              
                // Calculate the price per entry needed to add up to the total quote price
                pricePerEntry = Math.max(1.0, parseFloat(newValue)) / totalNumEntries; 

                // Update the individual values to this such that the entire quote will
                // add up to the value the hotelier just plucked from the sky
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        stdRate.rate = pricePerEntry;
                    });
                });
		    }
        }
*/
    }
</script>
